import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { ui } from '../data/ui';
interface TrustBadgesProps {
  tone?: 'light' | 'dark';
}
export function TrustBadges({
  tone = 'dark'
}: TrustBadgesProps) {
  const {
    t
  } = useLanguage();
  const items = [ui.licensedInsured, ui.yearsBadge, ui.familyOwned, ui.freeEstimatesBadge];
  const isDark = tone === 'dark';
  return <ul className={['flex flex-wrap items-center gap-x-6 gap-y-2 text-sm font-medium', isDark ? 'text-white/90' : 'text-ink/75'].join(' ')} data-id="element-353" data-mp="3cevvkaptleiq">
      {items.map(item => <li key={item.en} className="flex items-center gap-2" data-id="element-354" data-mp="3l7z547xch783">
          <BadgeCheckIcon className={isDark ? 'h-4 w-4 text-gold' : 'h-4 w-4 text-gold-dark'} aria-hidden="true" data-id="element-355" data-mp="3h6ndxxytodxs" />
          {t(item)}
        </li>)}
    </ul>;
}